import React from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

class OfflineErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if it's a network error
    const isNetworkError = 
      error.message?.includes('Network Error') ||
      error.message?.includes('Failed to fetch') ||
      error.message?.includes('timeout') ||
      !navigator.onLine;

    return { hasError: isNetworkError, error };
  }

  componentDidCatch(error, errorInfo) {
    console.log('Error boundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError && !navigator.onLine) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-blue-50 flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
            <div className="mb-6">
              <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <WifiOff className="h-10 w-10 text-orange-600" />
              </div>
              <h1 className="text-2xl font-bold text-gray-900 mb-2">
                You're Offline
              </h1>
              <p className="text-gray-600">
                No internet connection detected. HealthLoop works offline too!
              </p>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-left">
              <p className="text-sm text-blue-900 font-medium mb-2">What you can do:</p>
              <ul className="text-sm text-blue-800 space-y-1">
                <li>• View cached health tips</li>
                <li>• Log daily habits (syncs later)</li>
                <li>• Access saved recommendations</li>
              </ul>
            </div>

            <Button
              onClick={() => {
                this.setState({ hasError: false });
                window.location.reload();
              }}
              className="w-full bg-indigo-600 hover:bg-indigo-700"
            >
              <RefreshCw className="h-4 w-4 mr-2" />
              Reload App
            </Button>

            <p className="text-xs text-gray-500 mt-4">
              Data will sync automatically when you're back online
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default OfflineErrorBoundary;
